import { MapConfig, MapID } from '../navigator/navigator.model';

export type WorldConfig = {
  startingPOI: string;
  startingMap: MapID;
  maps: MapConfig[];
  mode?: 'map-builder';
};

export enum WorldEventBus {
  initialise = 'initialise',
}
